import { Card, CardContent, Grid, Popover, TextField, Typography, makeStyles } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { searchArray } from '../utils/Utils';

const useStyle = makeStyles({
  inputField: {
    width: '98%',
    padding: '20px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  optionsList: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    paddingLeft: '10px',
  },
  openListItemLable: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  optionText: {
    padding: ' 12px 10px',
    borderRadius: '4px',
    background: '#fefefe',
    width: '97%',
    border: 'none',
  },
  radioBtn: {
    color: '#622fee',
    width: '5px',
    height: '5px',
  },
  addOption: {
    color: '#622FEE',
    borderBottom: '2px solid #622FEE',
    display: 'inline',
    fontWeight: '600',
    cursor: 'pointer',
  },
  inputCard: {
    width: '400px',
    height: '50px',
    position: 'relative',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholder: {
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    padding: '10px',
  },
  arrowIcon: {
    position: 'absolute',
    top: 10,
    right: 0,
  },
  cardContent: {
    borderRadius: '8px',
    maxHeight: '400px',
    width: '400px',
    paddingBottom: '10px',
  },
  scrollableGrid: {
    // height: '320px',
    maxHeight: '320px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  searchText: {
    width: '100%',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
    marginBottom: '10px',
  },
  clear: {
    fontWeight: '500',
    fontSize: '12px',
    color: '#475467',
    cursor: 'pointer',
  },
  popover: {
    zIndex: 1,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '30px',
    cursor: 'pointer',
    '&:hover': {
      background: '#FAF9F6',
    },
  },
  clearSearch: {
    position: 'absolute',
    top: '50%',
    left: '97%',
    transform: 'translate(-97%, -50%)',
  },
});

export const Dropdown = ({ data, selectedData, setSelectedData, isSearchable, dropdownText }) => {
  const classes = useStyle();

  const [anchorEl, setAnchorEl] = useState(null);
  const [serachVal, setSearchVal] = useState('');
  const [filteredData, setFilteredData] = useState([]);

  const getSelectedItem = () => {
    const temp = data?.filter((d) => d.id === selectedData);
    return temp?.length > 0 ? temp[0].title : null;
  };

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    const temp = searchArray(data || [], ['title'], serachVal) || [];
    setFilteredData(temp);
  }, [serachVal]);

  const handleClick = (event, id) => {
    event.stopPropagation();
    setSelectedData(id);
    setAnchorEl(null);
  };

  return (
    <Card className={classes.inputCard} onClick={(e) => setAnchorEl(e.currentTarget)}>
      <Grid container>
        <Grid item xs={10}>
          <Typography noWrap className={classes.placeholder}>
            {selectedData ? getSelectedItem() : dropdownText}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <ArrowDropDown className={classes.arrowIcon} />
        </Grid>
      </Grid>
      {anchorEl && (
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          className={classes.popover}
          onClose={(e) => {
            e.stopPropagation();
            setAnchorEl(null);
          }}
        >
          <Card className={classes.cardContent}>
            <CardContent>
              {isSearchable && (
                <Grid container direction="row">
                  <Grid item xs={12} style={{ position: 'relative', height: '45px' }}>
                    <TextField
                      id="searchId"
                      name="search"
                      required
                      autoComplete="off"
                      autoSave="off"
                      placeholder="Search.."
                      InputProps={{
                        disableUnderline: true,
                        className: classes.searchText,
                      }}
                      value={serachVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      rows={1}
                      style={{ width: '100%' }}
                    />
                    {serachVal && (
                      <Grid className={classes.clearSearch} onClick={() => setSearchVal('')}>
                        <CloseIcon style={{ cursor: 'pointer', fontSize: '14px' }} />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}
              <Grid container direction="row">
                <Grid item className={classes.scrollableGrid} xs={12}>
                  {filteredData?.map((d) => (
                    <Grid className={classes.item} key={d.id} onClick={(e) => handleClick(e, d.id)}>
                      <Typography noWrap>{d.title}</Typography>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Popover>
      )}
    </Card>
  );
};
